export type UploadGeometryModalPropsProps = {
    title: string,
    titleIcon:  React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
        title?: string | undefined;
    }>,
    onClose: Function,
    isTriggeredByAdminDecision?: boolean
}

export enum UploadGeometryTypes {
    New,
    UpdateDefaultDb,
    UpdateWaitingRoom,
    Waiting
}